<template>
  <div v-show="cityList.length >= 1" class="citys">
    <div v-if="isCard">
      <p @click="showMoreCity">
        <span
          :class="cityList.length < 2 ? 'norCol' : ''"
          v-for="(item, i) in cityList"
          :key="i"
          >{{ item }}</span
        >
      </p>
      <div v-show="show" class="mor_panel">
        <div class="panel_mors">
          <div class="point"></div>
          <div class="city_con">
            <span v-for="(item, i) in cityList" :key="i">{{ item }}&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p @click="showMoreCity">
        <span
          :class="cityList.length < 2 ? 'norCol' : ''"
          v-for="(item, i) in cityList"
          :key="i"
          >{{ item.name }}</span
        >
      </p>
      <div v-show="show" class="mor_panel">
        <div class="panel_mors">
          <div class="point"></div>
          <div class="city_con">
            <span v-for="(item, i) in cityList" :key="i"
              >{{ item.name }}&nbsp;{{ item.count }}人</span
            >
          </div>
        </div>
      </div>
    </div>
    <van-popup
      :get-container="getContainer"
      v-model="show"
      overlay-class="panelView"
      :style="{ zIndex: '1' }"
    />
  </div>
</template>

<script>
export default {
  props: {
    cityList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
    hPanel: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 详情页展示citypanel
    showMoreCity() {
      if (this.cityList.length < 2) {
        return;
      }

      if (this.hPanel) {
        this.show = true;
      }
    },
    getContainer() {
      return document.querySelector(".citys");
    },
  },
};
</script>

<style lang="scss" scoped>
.citys {
  /* margin-right: 4px; */
  max-width: 70px;

  p {
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #5ebfb9;
    span {
      color: #5ebfb9;
      margin-right: 4px;
    }
    .norCol {
      color: #828282;
    }
  }
  position: relative;
  .mor_panel {
    position: absolute;

    padding-left: 24px;
    z-index: 2100;
    /* width: 100px;
          height: 100px; */
    top: 30px;
    left: -20px;

    color: white;
    width: 220px;

    .panel_mors {
      padding: 8px;
      position: relative;
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.6);
    }
    .city_con {
      display: flex;
      flex-wrap: wrap;
      span {
        margin-top: 4px;
        color: white;
        display: block;
        font-size: 16px;
        margin-left: 12px;
      }
    }
    .point {
      position: absolute;
      z-index: 2004;
      left: 40px;
      top: -21px;
      border: transparent 8px solid;
      border-bottom: rgba(0, 0, 0, 0.6) 14px solid;
    }
  }
}
::v-deep {
  .van-overlay {
    background: transparent;
  }
}
</style>
